import {useStaySummary as useSharedStaySummary} from '@chekin/shared/home';
import {useSummary} from 'context/summary';
import {useReservation} from 'context/reservation';

function useStaySummary() {
  const {data: summary} = useSummary();
  const {data: reservation} = useReservation();

  return useSharedStaySummary({summary, reservation});
}

export {useStaySummary};
